import React, { SVGProps } from 'react';

const ThreeDotsIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M16.125 10.875C17.1605 10.875 18 10.0355 18 8.99998C18 7.96446 17.1605 7.125 16.125 7.125C15.0895 7.125 14.25 7.96446 14.25 8.99998C14.25 10.0355 15.0895 10.875 16.125 10.875Z"
                fill="white"
            />
            <path
                d="M8.99998 10.875C10.0355 10.875 10.875 10.0355 10.875 8.99998C10.875 7.96446 10.0355 7.125 8.99998 7.125C7.96446 7.125 7.125 7.96446 7.125 8.99998C7.125 10.0355 7.96446 10.875 8.99998 10.875Z"
                fill="white"
            />
            <path
                d="M1.87499 10.875C2.91052 10.875 3.74998 10.0355 3.74998 8.99998C3.74998 7.96446 2.91052 7.125 1.87499 7.125C0.839461 7.125 0 7.96446 0 8.99998C0 10.0355 0.839461 10.875 1.87499 10.875Z"
                fill="white"
            />
        </svg>
    );
};

export default ThreeDotsIcon;
